var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-notice-bar',{attrs:{"left-icon":"volume-o","text":_vm.schema.text,"background":_vm.schema.bgColor,"color":_vm.schema.color,"scrollable":_vm.schema.scrollable,"wrapable":_vm.schema.wrapable,"speed":_vm.schema.speed}})
}
var staticRenderFns = []

export { render, staticRenderFns }